export default [{
  path: '/backoffice',
  name: 'backoffice-view',
  component: () => import('@/views/apps/backoffice/view.vue'),
}, {
  path: '/backoffice/project-view/:project',
  name: 'backoffice-view-project',
  component: () => import('@/views/apps/backoffice/view.vue')
}]